import { useMutation } from '@tanstack/react-query';

import { ExportEntityType, ExportParams } from '@/module/Export/model/ExportTypes';

import * as api from './ExportApi';

export function useExportEntity(entityType: ExportEntityType) {
  return useMutation({
    mutationFn: (params: ExportParams) => api.downloadEntityExport(entityType, params),
  });
}
